import React from 'react';
import { Modal } from './ui/Modal';
interface Props {
  isOpen: boolean;
  onClose: () => void;
}
export function PrivacyModal({
  isOpen,
  onClose
}: Props) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Políticas de Privacidad" data-id="element-26">
      <div className="space-y-4" data-id="element-27">
        <p data-id="element-28">
          <strong data-id="element-29">1. Recopilación de Información</strong>
          <br data-id="element-30" />
          Recopilamos información cuando usted realiza una compra o se registra
          en nuestro sitio. La información recopilada incluye su nombre,
          dirección de correo electrónico y datos de pago (procesados de forma
          segura por terceros).
        </p>

        <p data-id="element-31">
          <strong data-id="element-32">2. Uso de la Información</strong>
          <br data-id="element-33" />
          Cualquier información que recopilamos de usted puede ser utilizada
          para: personalizar su experiencia, mejorar nuestro sitio web, procesar
          transacciones y enviar correos electrónicos periódicos relacionados
          con su compra.
        </p>

        <p data-id="element-34">
          <strong data-id="element-35">3. Protección de la Información</strong>
          <br data-id="element-36" />
          Implementamos una variedad de medidas de seguridad para mantener la
          seguridad de su información personal cuando realiza un pedido.
          Utilizamos plataformas de pago seguras y encriptadas.
        </p>

        <p data-id="element-37">
          <strong data-id="element-38">4. Uso de Cookies y Píxeles</strong>
          <br data-id="element-39" />
          Utilizamos cookies y tecnologías de seguimiento (como el Píxel de
          Meta) para comprender y guardar sus preferencias para futuras visitas
          y recopilar datos agregados sobre el tráfico del sitio para ofrecer
          mejores experiencias.
        </p>

        <p data-id="element-40">
          <strong data-id="element-41">5. Divulgación a Terceros</strong>
          <br data-id="element-42" />
          No vendemos, intercambiamos ni transferimos a terceros su información
          personal identificable. Esto no incluye a los terceros de confianza
          que nos asisten en la operación de nuestro sitio web o en la
          realización de nuestro negocio.
        </p>
      </div>
    </Modal>;
}